(async () => {
  const el = document.getElementById('lpu-page-otzivi')

  if (!el) {
    return
  }

  const { default: clientRender } = (await import(/* webpackMode: 'eager' */ 'vue-compiler/clientRender'))

  const components = [
    {
      el,
      componentImport: () => import(/* webpackMode: 'eager' */ 'src/pages/[town-translit]/lpu/[lpu-translit]/otzivi/index.vue'),
    },
  ]

  await clientRender({ components })
})()
